export * from './feature-detail-tool.component';
